import React, { useContext } from 'react';

/* Images */
import placeholder from '~/../img/vehicle-placeholder.png';

/* Common */
import CardProduct from '../../common/cards/CardProduct';

/* Context */
import { StaticData } from '~/context/staticData';

/* Utilities */
import { getSuffix, trans } from '~/utilities';

export default function ProductOverviewProduct({ vehicle, stickerTooltips, favorites }) {
    const { images, price, attributes, enrichedValues, url, brand, model, type, id } = vehicle;

    const source = attributes?.source?.value;
    const adBusinessLeasePrice = attributes?.ad_business_lease_price?.value;

    const {
        customOptions: { vehicleSpecs, businessLeaseVop, privateLeasePrices, operationalLeasePrices, ctaCard, userLoggedIn, extranetLoginUrl, extranetRegisterUrl, saveFavoriteUrl, removeFavoriteUrl, getFavoritesUrl, leaseType, hideLocation, hideFavorites },
    } = useContext(StaticData);

    let vehicleSpecsAll = vehicleSpecs;

    const specs = vehicleSpecsAll.map((spec) => {
        const attribute = attributes[spec];
        if (typeof attribute !== 'undefined') {
            if (attribute.code === 'tellerstand') {
                return `${ attribute.value.toLocaleString('nl-NL') } km`;
            }

            if (attribute.code === 'actieradius_elektrisch') return attribute.value + getSuffix(attribute.code) + ' actieradius';
            if (attribute.code === 'accu_capaciteit') return attribute.value + getSuffix(attribute.code);

            return attribute.value + getSuffix(attribute.code);
        }
        return null;
    }).filter((spec) => (spec !== null));

    //const image = images?.find((image) => image.filter === 'vehicle_image' && image.position === 1);

    return (
        <CardProduct
            title={`${ brand } ${ model }`}
            subtitle={`${ type } ${ attributes?.toevoeging?.value || '' }`}
            model={model}
            images={images?.map((image) => ({
                src: image?.path || `${window.location.origin}${placeholder}`,
                alt: image?.description || `${brand} ${model} ${type}`,
            }))}
            location={enrichedValues?.vestiging_naam}
            specs={specs}
            price={
                {
                    title: trans('app.vehicle_prices.price.title'),
                    value: price,
                    discount: attributes.actieprijs.value,
                    type: 'price'
                }
            }
            lease={
                {
                    title: trans('app.vehicle_prices.finance_price.title'),
                    value: enrichedValues.finance_price,
                    type: 'finance_price'
                }
            }
            privateLease={
                {
                    title: trans('app.vehicle_prices.private_lease.title'),
                    value: enrichedValues.private_lease,
                    type: 'private_lease'
                }
            }
            operationalLease={
                {
                    title: trans('app.vehicle_prices.business_lease.title'),
                    // FOL, or the Autodisk price of a company car (WAAL-1244, ADR-001). Falls back to
                    // business_lease, which is often the private lease amount, so other pages keep showing
                    // what they did. ALMN lists only hold vehicles with an ALMN lease price.
                    value: enrichedValues.almn_lease_price ?? enrichedValues.business_lease,
                    type: 'business_lease'
                }
            }
            href={leaseType ? `${url}?lease_type=${leaseType}` : url}
            vehicleType={attributes?.voertuigsoort?.value}
            btwMarge={attributes?.btw_marge?.value}
            sticker={enrichedValues?.sticker}
            availability={enrichedValues?.availability}
            stickerTooltips={stickerTooltips}
            cardTitle={ctaCard?.title}
            cardTheme={ctaCard?.theme}
            favorites={favorites}
            id={id}
            businessLeaseVop={businessLeaseVop}
            onlyPrivateLeasePrices={privateLeasePrices}
            onlyOperationalLeasePrices={operationalLeasePrices}
            userLoggedIn={userLoggedIn}
            extranetLoginUrl={extranetLoginUrl}
            extranetRegisterUrl={extranetRegisterUrl}
            saveFavoriteUrl={saveFavoriteUrl}
            removeFavoriteUrl={removeFavoriteUrl}
            getFavoritesUrl={getFavoritesUrl}
            hideLocation={hideLocation}
            hideFavorites={hideFavorites}
            source={source}
            businessLeasePrice={adBusinessLeasePrice}
        />
    );
}
